import React,{ useState} from 'react';
import { useSelector,  connect} from 'react-redux';
import OfferCard from './OfferCard';
import ButtonThree from '../elements/ButtonThree';
import {mapInsCompMsgCode} from '../../../../app/common/services/vehicle.service';
import NuInsStepper from '../elements/NuInsStepper';
import {steppLabels} from './common/types';
import {BackIcon} from '../svg/iconsSvg';

const OffersList = ({onBack, onForward, style}) => {
    const { offers } = useSelector(state => state.insOffers);
    const insCompanies = useSelector(state => state.insCompanies);
    const [installment, setInstallment] = useState(1);

    const updateInstalment = (installmentNumber) => {
        setInstallment(installmentNumber);
    }

    const insOffersCompare = (a, b) => {
    let offerA = 0, offerB = 0;
    if (offers[a] && offers[a][installment]?.totalAmount) {
        offerA = offers[a][installment].totalAmount;
    } else if (offers[a] && offers[a][installment]?.totalAmount === 0 ) {
        offerA = 100000;
    }
    else if (offers[a] && offers[a][installment]?.data) {
        offerA = 10000;
    }

    if (offers[b] && offers[b][installment]?.totalAmount) {
        offerB = offers[b][installment].totalAmount;
    } else if (offers[b] && offers[b][installment]?.totalAmount === 0) {
        offerB = 100000;
    } else if (offers[b] && offers[b][installment]?.data) {
        offerB = 10000;
    }

    if(offerA && !offerB) return -1;
        
    if(!offerA && offerB) return 1;
        
    if(!offerA && !offerB) return 0;

    return offerA - offerB;
}

    const renderOffers = () => {
        insCompanies.sort(insOffersCompare);

        return insCompanies.map((company, i) => {
            let msgCode;
            const installments = offers[company] 
                ? offers[company][installment]?.installments 
                ? offers[company][installment]?.installments[0].valuesEUR 
                ? offers[company][installment]?.installments[0].valuesEUR
                : []
                : []
                : [];

            const totalAmountEUR = offers[company] ? offers[company][installment]?.totalAmountEUR : null;

            const totalAmountLEVA = offers[company] ? offers[company][installment]?.totalAmount : null;
            
            if(!installments.length && offers[company] && offers[company][installment]?.data) {
                const messageCode = offers[company][installment].data.messageCode;
                msgCode = messageCode ? mapInsCompMsgCode(messageCode, installment) : null;

            } else if(!installments.length && offers[company] && offers[company][installment]?.totalAmount === 0) {
                msgCode = "Не се предлага";
            }

            return <OfferCard onForward={()=>onForward(7)} totalAmountEUR={totalAmountEUR} insCompany={company} installments={installments} totalAmountLEVA={totalAmountLEVA} msgCode={msgCode} key={i} />
        })
    }

    const goBack = () => {
        onBack(4);
    }

    return (
        <div className="steps_container" style={style}>
            <div className="head" style={{paddingTop: '0', marginBottom: '-18px'}}>
                <div className="head-icon" style={{margin: '0 -8px 0 4px'}} onClick={goBack}><BackIcon size={32}/></div>
                <NuInsStepper activeStep={2} steps={4} labels={steppLabels}/>              
            </div>

            <ButtonThree onChange={updateInstalment} installment={installment}/>
            {renderOffers()}
        </div>    
    )
}

export default connect(null, null)(OffersList);


// const insOffersCompareOld = (a, b) => {
//     const offerA = offers[a] 
//         ? offers[a][installment].totalAmount 
//         ? offers[a][installment].totalAmount : 0 : 0;
    
//     const offerB = offers[b] 
//         ? offers[b][installment].totalAmount 
//         ? offers[b][installment].totalAmount : 0 : 0;

//     if(offerA && !offerB) return -1;
        
//     if(!offerA && offerB) return 1;
        
//     if(!offerA && !offerB) return 0;

//     return offerA - offerB;
// }